import React from "react";
import { useNavigate } from "react-router-dom";
import "../exercise1/Exercise1Failed.css"; 

const Exercise4Failed = () => {
  const navigate = useNavigate();

  const handleRetry = () => {
    navigate("/exercise4intro");
  };

  return (
    <div className="exercise1-failed-container">
      <div className="failed-content">
        <h1>Try Again</h1>
        <p>
          This time, make sure to breathe properly and stay focused.  
          Take your time and try again!
        </p>
        <button className="retry-button" onClick={handleRetry}>
          Try Again
        </button>
      </div>
    </div>
  );
};

export default Exercise4Failed;
